module.exports = {"see-more":"Read +","see-less":"Close"}


//////////////////
// WEBPACK FOOTER
// ./src/i18n/en.json
// module id = 91
// module chunks = 0